import CityPageTemplate from "../city-template/CityPageTemplate";
import { caldwellConfig } from "./data";

export default function CaldwellPage() {
  return <CityPageTemplate config={caldwellConfig} />;
}